module.exports = __webpack_public_path__ + "static/img/zhuPic.52eb983a.png";